import { Outlet, createFileRoute } from "@tanstack/react-router";

export const Route = createFileRoute("/lab")({
  component: RouteComponent,
});

function RouteComponent() {
  return (
    <div className="mx-auto max-w-2xl p-4 border flex gap-6">
      <Outlet />
    </div>
  );
}
